import { useCallback, useEffect, useState } from "react";
import _debounce from "lodash/debounce";
import { MEDIA_QUERIES } from "utils/media";

export const useResponsive = (timeout = 200) => {
  const [state, setState] = useState({});

  const handleResize = () => {
    const breakpoints = Object.assign(
      {},
      ...Object.keys(MEDIA_QUERIES).map(key => {
        const camelCaseKey = `is${key
          .split("_")
          .map(word => `${word.charAt(0)}${word.toLowerCase().slice(1)}`)
          .join("")}`;

        const { size, type } = MEDIA_QUERIES[key];

        return { [camelCaseKey]: type === "max" ? window.innerWidth <= size : window.innerWidth > size };
      })
    );

    setState(breakpoints);
  };

  const debounceHandleResize = useCallback(_debounce(handleResize, timeout), []);

  useEffect(() => {
    handleResize();
    window.addEventListener("resize", debounceHandleResize);
    return () => window.removeEventListener("resize", debounceHandleResize);
  }, []);

  return state;
};
